import React from "react";
import { Prose } from "components/atoms/Prose";
import { Aside, Emoji } from "./Note.styled";
interface NoteProps {
  emoji?: string;
  children: React.ReactNode;
}
export const Note: React.FC<NoteProps> = ({
  emoji,
  children
}) => {
  return <Aside data-sentry-element="Aside" data-sentry-component="Note" data-sentry-source-file="index.tsx">
            {emoji ? <Emoji>{emoji}</Emoji> : null}
            <Prose data-sentry-element="Prose" data-sentry-source-file="index.tsx">{children}</Prose>
        </Aside>;
};